import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const fieldsTypeSlice = createSlice({
  name: "fieldsType",
  initialState,
  reducers: {
    fetchFieldsTypeStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchFieldsTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchFieldsTypeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchFieldsTypeStart,
  fetchFieldsTypeSuccess,
  fetchFieldsTypeFailure,
} = fieldsTypeSlice.actions;
export default fieldsTypeSlice.reducer;
